<template>
    <Breadcrumbs main="Ui Kits" title="Lists" />
    <div class="container-fluid">
        <div class="row">
            <defaultLists />
            <activeLists />
            <flushLists />
            <contextualClasses />
            <horizontalLists />
            <customList />
            <checkboxRedio />
            <numberList />
            <javaScriptBehavior />
            <badgeList />
            <disabledLists />
            <scrollableLists />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const defaultLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/defaultLists.vue"))
const activeLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/activeLists.vue"))
const flushLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/flushLists.vue"))
const contextualClasses = defineAsyncComponent(() => import("@/components/theme/uikits/lists/contextualClasses.vue"))
const horizontalLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/horizontalLists.vue"))
const customList = defineAsyncComponent(() => import("@/components/theme/uikits/lists/customList.vue"))
const checkboxRedio = defineAsyncComponent(() => import("@/components/theme/uikits/lists/checkboxRedio.vue"))
const numberList = defineAsyncComponent(() => import("@/components/theme/uikits/lists/numberList.vue"))
const javaScriptBehavior = defineAsyncComponent(() => import("@/components/theme/uikits/lists/javaScriptBehavior.vue"))
const badgeList = defineAsyncComponent(() => import("@/components/theme/uikits/lists/badgeList.vue"))
const disabledLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/disabledLists.vue"))
const scrollableLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/scrollableLists.vue"))
</script>